import { Form, FormInstance } from "antd";
import { useEffect } from "react";

export const useSetMissingFileError = (form: FormInstance, name: string) => {
  const file = Form.useWatch(name, form);

  useEffect(() => {
    if (file && file.length > 0) {
      file[0].isMissing &&
        form.setFields([
          {
            name: [name],
            errors: [
              "Wasn’t able to migrate the file from the previous system",
            ],
          },
        ]);
    }
  }, [file, form, name]);
};
